export default __webpack_public_path__ + "static/media/biking.1146d108.jpg";